import { assign } from 'lodash';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from '@medsurf/flat-validators';

@Component({
    selector: 'medsurf-slide-main-toolbar-title',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './title.component.html',
    styleUrls: ['./title.component.scss'],
    standalone: false
})
export class TitleComponent {
  #isSubmitted = signal(false);
  #page: FlatModels.PageEntityModels.PageEntityType | null;
  titleForm = new FormGroup(
    {
      title: new FormControl(''),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.PageEntityModels.FolderSchema.pick({
          title: true,
        })
      ),
      updateOn: 'change'
    }
  );
  readonly FlatModels = FlatModels;
  
  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public nodeSharedFacade: FlatFacades.NodeSharedFacade) {
    // Update Page
    this.nodeSharedFacade.currentSelectedPage$.pipe(takeUntilDestroyed()).subscribe((page) => {
      this.#page = structuredClone(page);
      if (this.#page) {
        if (this.titleForm.value['title'] !== this.#page['title']) {
          this.titleForm.reset(this.#page);
        }
      }
      this.#isSubmitted.set(false);
    });
  }

  onSubmit() {
    if (this.#isSubmitted() || this.titleForm.invalid || !this.#page) {
      return;
    }
    this.#isSubmitted.set(true);
    
    // Update Page
    const page = assign(this.#page, {
      title: this.titleForm.value['title']
    });
    this.nodeSharedFacade.requestUpdatePage(page, 'history.page_update_title').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.titleForm);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
}
